export const KeyBoardAction = {
    enter: 13
};

export const BREAK_POINT = {
    BREAK_POINT_DESKTOP: 1281,
    BREAK_POINT_TABLET: 1024,
    BREAK_POINT_MOBILE: 768
};

export const isMobileDevice = {
    Android: () => (window.navigator.userAgent.match(/Android/i)),
    BlackBerry: () => (window.navigator.userAgent.match(/BlackBerry/i)),
    iPad: () => (window.navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
        (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1) /* iPad OS 13+ */),
    iOS: () => (window.navigator.userAgent.match(/iPhone|iPad|iPod|ios/i) || isMobileDevice.iPad()),
    MAC: () => (window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)),
    Windows: () => (window.navigator.userAgent.match(/IEMobile/i)),
    any: () => (isMobileDevice.Android() || isMobileDevice.BlackBerry() || isMobileDevice.iOS() || isMobileDevice.Windows())
};

export const isMobile = () => window.matchMedia(`(max-width: ${BREAK_POINT.BREAK_POINT_MOBILE - 1}px)`).matches;
